import React, { Component, createRef } from 'react';
import SectionHeader from './SectionHeader';
import Card4 from '../cards/Card4';

import celt_az from '../../images/project/celt_az.png'
import celt_vip from '../../images/project/celt_vip.png'
import celt_go from '../../images/project/celt_go.png'

export class ProjectMP extends Component {
    constructor(props) {
        super(props);
        this.sectionRef = createRef();
        this.state = {
            isVisible: false
        };
    }

    componentDidMount() {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    this.setState({ isVisible: true });
                    observer.disconnect(); // Bir kere görünce gözlemlemeyi bırak
                }
            },
            { threshold: 0.1 } // Bölümün %10'u görünür olduğunda tetiklenir
        );

        if (this.sectionRef.current) {
            observer.observe(this.sectionRef.current);
        }
    }

    render() {
        const { className } = this.props;
        return (
            <section className={`${className} pt-[52px] pb-[72px]`}

            >
                <div className='container'>
                    <div className='flex flex-col gap-[12px] items-center'>
                        <span className='text-[var(--orange)] text-[16px] font-[600]'>Layihələrimizə Bir Baxın</span>

                        <SectionHeader
                            title='Layihələr'
                            className="max-w-[750px] text-center"
                        />
                    </div>

                    <div
                        ref={this.sectionRef}
                        className={`fade-in-section   grid grid-cols-3 gap-[32px] mt-[32px] max-[1001px]:grid-cols-2 max-[650px]:grid-cols-1 ${this.state.isVisible ? 'visible' : ''}`}>
                        <Card4
                            img={celt_az}
                            title="CELT.az"
                            path="https://www.celt.az/"

                        />
                        <Card4
                            img={celt_vip}
                            title="CELT.vip"
                            path="https://celt.vip/"
                        />
                        <Card4
                            img={celt_go}
                            title="CELT.go"
                            path="https://celtgo.com/"
                        />
                    </div>
                </div>
            </section>
        );
    }
}

export default ProjectMP;